import * as React from "react";
import { Field, useFormikContext } from "formik";
import { Input } from "components/bootstrap";
const checkboxProps = (value) => ({ checked: value != null ? value : false });
const inputProps = (value) => ({ value: value != null ? value : "" });
const FormikInput = ({
  children,
  disabled = false,
  required = false,
  autoFocus = false,
  name,
  type = "text",
  help,
  validate = () => void 0,
  onChange: propagateOnChange,
  error: errorProp,
  ...rest
}) => {
  const { validateOnChange } = useFormikContext();
  return /* @__PURE__ */ React.createElement(Field, { name, validate }, ({ field: { value, onChange, onBlur }, meta: { error: validationError, touched } }) => {
    const typeSpecificProps = type === "checkbox" ? checkboxProps(value) : inputProps(value);
    const displayValidationError = validateOnChange ? !!(validationError && touched) : !!validationError;
    const error = displayValidationError ? validationError : errorProp;
    const _handleChange = (e) => {
      if (typeof propagateOnChange === "function") {
        propagateOnChange(e);
      }
      onChange(e);
    };
    return /* @__PURE__ */ React.createElement(
      Input,
      {
        ...rest,
        disabled,
        required,
        autoFocus,
        ...typeSpecificProps,
        onBlur,
        help,
        id: name,
        error,
        onChange: _handleChange,
        type
      },
      children
    );
  });
};
export default FormikInput;
